import api from '@/api';
import { API_BASE_URL } from '../../index';
import { QuestReportOsXFinancialRequest } from '../../Reports/OsXFinancial/OsXFinancial.types';

const CONTROLLER_URL = `${API_BASE_URL}/Csv`;

export async function getQuestReportOsXFinancialCsv(
  params: QuestReportOsXFinancialRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/OsXFinancial`,
    params,
  )) as unknown;

  return result as BlobPart;
}
